module.exports = __webpack_public_path__ + "media/application/images/2020/redesign2020-header-menu-close-57eddfc04ea2fbdbb986860226c9113c.svg";